/**
 * --- KONSEP: PENJAGA PINTU (PROTECTED ROUTE) ---
 * File ini bertugas sebagai "Satpam". Ia mengecek apakah pengguna sudah
 * Login atau belum. Jika belum login, pengguna akan ditendang balik
 * ke halaman Login dan tidak bisa melihat isi aplikasi.
 */
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

export const ProtectedRoute = () => {
  const { user, loading } = useAuth(); // Mengambil status login dari Sistem Keamanan

  // Jika sistem masih loading (sedang mengecek kunci/session)
  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-surface">
        <div className="w-10 h-10 border-4 border-primary border-t-transparent rounded-full animate-spin"></div>
      </div>
    );
  }

  // --- LOGIKA UTAMA: Cek Kelayakan ---
  // Jika ternyata user tidak login, arahkan paksa ke halaman login
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Jika user sudah login, izinkan masuk ke halaman yang dituju (Outlet)
  return <Outlet />;
};

export default ProtectedRoute;
